import React from 'react';
import FrameMenu from './FrameMenu';
import Stylus from './Stylus';
import type WhiteboardController from '../controllers/WhiteboardController';

class StylusCurrentFrame extends Stylus {
  private currentStylus: Stylus;

  constructor({
    controller,
    currentStylus,
  }: {
    controller: WhiteboardController;
    currentStylus: Stylus;
  }) {
    super({ controller });
    this.currentStylus = currentStylus;
  }

  activate(): void {
    this.currentStylus.activate();
  }

  subMenu() {
    if (!window.currentAccount?.whiteboardsAdvanced) {
      return null;
    }
    return FrameMenu;
  }

  subMenuName() {
    return 'frames';
  }

  iconClass() {
    return 'fa-regular fa-frame';
  }

  renderIcon() {
    return <aha-icon icon={this.iconClass()} />;
  }

  description(): string {
    return 'Frame';
  }

  setCurrentStylus(stylus: Stylus): void {
    this.currentStylus = stylus;
  }

  cursor() {
    return this.currentStylus.cursor();
  }

  stylusId() {
    return 'frame';
  }
}

export default StylusCurrentFrame;
